import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  gap: 24px;
  background-color: #fff;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`

export const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0;
`

export const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 12px;
  }
`

export const QueueGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`

export const QueueCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(10, 30, 61, 0.08);
  }
`

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #0a1e3d;

  div {
    margin: 0;
  }

  strong {
    font-weight: 600;
  }
`

export const CardActions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

export const CandidateList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
  border-top: 1px solid #e0e0e0;
  padding-top: 8px;
`

export const CandidateRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  color: #0a1e3d;
  flex-wrap: wrap;
`

export const CandidateUrl = styled.a`
  color: #1a73e8;
  text-decoration: none;
  word-break: break-all;
  flex: 1;

  &:hover {
    text-decoration: underline;
  }
`

export const ScoreBadge = styled.span<{ score: number }>`
  background-color: ${({ score }) => (score >= 60 ? '#4caf50' : score >= 30 ? '#ff9800' : '#e0e0e0')};
  color: ${({ score }) => (score >= 30 ? '#fff' : '#666')};
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
`

export const StatusBadge = styled.span<{ status: string }>`
  background-color: ${({ status }) =>
    status === 'ACCEPTED' ? '#4caf50' : status === 'REJECTED' ? '#f44336' : '#9e9e9e'};
  color: #fff;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`

export const PaginationInfo = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #0a1e3d;
  white-space: nowrap;
`

export const PaginationControls = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const PageSizeControl = styled.div`
  min-width: 150px;

  @media (max-width: 768px) {
    width: 100%;
  }
`
